export enum FilterType {
  group = "group",
  student = "student",
  test = "test",
  company = "company",
}
